import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import * as _ from 'lodash'
import cx from 'classnames'

const FollowUpMessage = ({ actionGroup, name = 'followupMessage' }) => {
  const actionFormPath = `${name}${actionGroup ? '.' + actionGroup : ''}`
  const actionTypeFormPath = `${actionFormPath}.followupMessage`

  const {
    control,
    setValue,
    register,
    trigger,
    formState: { errors }
  } = useFormContext()

  const followUpMsgErrors = _.get(errors, actionTypeFormPath)
  return (
    <div className='select-action'>
      <label className='action-label'> Follow up message </label>
      <Controller
        name={actionTypeFormPath}
        control={control}
        shouldUnregister
        rules={{
          required: {
            value: true,
            message: 'Follow up message is required'
          }
        }}
        render={({ field: { value, onChange, errors }, formState }) => {
          return (
            <React.Fragment>
              <input
                type='text'
                name={actionTypeFormPath}
                className={cx('form-control', 'followup-input', { 'is-invalid': followUpMsgErrors })}
                placeholder='Enter message'
                {...register(actionTypeFormPath)}
                onBlur={(e) => {
                  const value = e.target.value?.trim() ?? ''
                  setValue(actionTypeFormPath, value)
                  trigger(actionTypeFormPath)
                }}
                onChange={(e) => onChange(e.target.value)}
                defaultValue=''
              />
            </React.Fragment>
          )
        }}
      />
      {followUpMsgErrors && <small className='form-text text-danger'>{followUpMsgErrors?.message}</small>}
    </div>
  )
}

export default FollowUpMessage
